import { Component, ViewChild, AfterViewInit, inject } from '@angular/core';
import {FormGroup, FormBuilder, ReactiveFormsModule} from '@angular/forms';
import {
  MatDatepickerToggle,
  MatDateRangeInput,
  MatDateRangePicker,
  MatEndDate,
  MatStartDate
} from '@angular/material/datepicker';
import {TranslateModule} from "@ngx-translate/core";
import {MatError, MatFormField} from "@angular/material/select";
import {MatLabel, MatSuffix} from "@angular/material/input";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-date-picker-range',
  templateUrl: 'date-picker-range.component.html',
  standalone: true,
  imports: [
    MatFormField,
    TranslateModule,
    MatStartDate,
    ReactiveFormsModule,
    MatSuffix,
    MatEndDate,
    MatError,
    MatDateRangePicker,
    MatDatepickerToggle,
    MatDateRangeInput,
    MatLabel,
    NgIf
  ],
  styleUrls: ['date-picker-range.component.scss']
})
export class DatePickerRangeComponent implements AfterViewInit {
  private fb = inject(FormBuilder);

  range: FormGroup;

  @ViewChild( MatDateRangePicker ) picker: MatDateRangePicker<Date>;

  @ViewChild( MatDateRangeInput ) dateRangeInput: MatDateRangeInput<Date>;

  constructor() {
    this.range = this.fb.group( {
      start: [ null ],
      end: [ null ],
    } );
  }

  ngAfterViewInit() {
    // Open the date range picker after the view has initialized
    setTimeout( () => {
      if ( this.picker && this.dateRangeInput ) {
        this.picker.open();
      }
    }, 0 );
  }
}
